import { useTranslation } from '@front10/utils';
import { Icon } from './Icon2';
import * as React from 'react';
import { AbsolutePosition } from './AbsolutePosition';
import Button from './Button2';

interface CloseButtonProps extends React.ComponentPropsWithoutRef<typeof Button> {
  closeButtonRef?: React.RefObject<HTMLButtonElement>;
}

export function CloseButton({ closeButtonRef, variant, ...props }: CloseButtonProps) {
  const translate = useTranslation();
  return (
    <AbsolutePosition top="8px" right="10px" sx={{ zIndex: 1 }}>
      <Button
        aria-label={translate('cmp-booking-popup-close-button', 'close')}
        variant={variant || 'icon'}
        {...props}
        ref={closeButtonRef}
      >
        <Icon icon="close" size={16} />
      </Button>
    </AbsolutePosition>
  );
}
